import { Component, OnInit } from '@angular/core';
import { UserGroup} from '../../../_models/user_group';
import { UserZone} from '../../../_models/user_zone';
import { Zone} from '../../../_models/zone';
import * as fromUserGroup from '../../../userGroup/state/userGroup.reducer';
import * as userGroupActions from '../../../userGroup/state/userGroup.actions';
import { Store, select } from '@ngrx/store';
// import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './userGroup-shell.component.html'
})

export class UserGroupShellComponent implements OnInit {

    // componentActive = true;
    // errorMessage$: Observable<string>;
    userGroups$: Observable<UserGroup[]>;
    currentUserGroup$: Observable<UserGroup>;
    zoneUserList$: Observable<UserZone[]>;
    zoneList$: Observable<Zone[]>;
    filterFields$: Observable<any>;

  constructor(
    private store: Store<fromUserGroup.State>
  ) {
    // Se cargan en esta página los datos futuros necesarios para
    // la página de edición para que puedan ser usados al cargarse esta.
    this.store.dispatch( new userGroupActions.LoadUserZones(null));
    this.store.dispatch( new userGroupActions.LoadZones(null));
  }

  ngOnInit() {

    // this.store.pipe(select(fromUserGroup.getUserGroupList),
    //   takeWhile(() => this.componentActive))
    //   .subscribe(
    //   userGroups => {
    //         console.log(' >>>> Suscribirse a store getUserGroupList: ');
    //         console.log(userGroups);

    //         this.userGroups = userGroups;
    //       }
    // );

    this.userGroups$ = this.store.pipe(select(fromUserGroup.getUserGroupList)) as Observable<UserGroup[]>;
    this.currentUserGroup$ = this.store.pipe(select(fromUserGroup.getCurrentUserGroup)) as Observable<UserGroup>;
    this.zoneUserList$ = this.store.pipe(select(fromUserGroup.getUserZoneList)) as Observable<UserZone[]>;
    this.zoneList$ = this.store.pipe(select(fromUserGroup.getZoneList)) as Observable<Zone[]>;
    this.filterFields$ = this.store.pipe(select(fromUserGroup.getFilterFields)) as Observable<any>;
  }

  searchUserGroups(searchParams): void {

    console.log('---> GetUserGroupList searchParam ');
    console.log(searchParams);

    this.store.dispatch( new userGroupActions.LoadUserGroups(searchParams));
    // Se guarda el valor de los filtros de búsqueda de las obras.
    this.store.dispatch( new userGroupActions.SetFilterFields(searchParams));

  } // End function searchUserGroups

  setCurrentUserGroup(userGroupIn: UserGroup | null): void {

    console.log('---> setCurrentUserGroup userGroupIn ');
    console.log(userGroupIn);

    this.store.dispatch( new userGroupActions.SetCurrentUserGroup(userGroupIn));

  } // End function setCurrentUserGroup

  deleteUserGroup(deleteUserGroup: UserGroup): void {

    console.log('---> deleteUserGroup: ');
    console.log(this.deleteUserGroup);

    this.store.dispatch( new userGroupActions.DeleteUserGroup(deleteUserGroup));

  } // End function deleteUserGroup

} // End class UserGroupShellComponent
